import { render } from "./create_questions.html?vue&type=template&id=f1aeabde&external"
import script from "./create_questions.js?vue&type=script&lang=js&external"
export * from "./create_questions.js?vue&type=script&lang=js&external"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__